import React, { Component } from 'react';
import { Container, Tabs, Tab, Button } from 'react-bootstrap';
import { FaPlus, FaTrash, FaPen, FaFileLines } from "react-icons/fa6";
import MenuLeftCMS from './ct-fragmentsidemenu';
import { GetText } from '../config/helper';
import '../config/global';
import CTNA from './ct-fragmentna';
import Popup from '../inc/PopUp';
import CTCategoryForm from './ct-category-form';
import CTCategoryDetail from './ct-category-detail';


const authKey = global.config.kindcode.training[3]+global.config.authBearerKey;

function loadContent(usedfor,keyword,pageshow) {
  return new Promise((resolve) => {
    var datatext ='{"keyword":"'+keyword+'","pageShow":"'+pageshow+'","usageFor":"'+usedfor+'"}';
    var data = JSON.parse(datatext); 
    fetch(global.config.urlLink+"/categorylist", {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
    }).then(response => {
        if(response.status === 200) {
            return response.json()
        } else {
            console.log('Something happened wrong');
            console.log(response);
        }
    }).then(resJson => {
        resolve(resJson);
    }).catch(err => {
        console.log(err);
        resolve({"status": "500"});
        
    });
  });
}

export default class CTCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stTitle: {"ENG": '', "IDN": ''},
      pageShow: '10',
      keyword: '',
      data: {"library": [], "course": [], "prompt": [], "discussion": []},
      stPopTitle: '',
      isOpen: false,
      isOpen2: false,
      otherContent: '',
      defTabIndex: "",
      usageFor: '',
      activelink:"none"
    }

    this.loadData = this.loadData.bind(this);
  }

  togglePopClose() {
    this.setState( prevState => {
      return {  
          ...prevState.isOpen, isOpen: false,
          ...prevState.isOpen2, isOpen2: false,
      }
    })
  }  
  urlviewCat(used,id,action) {
    var stPopTitle = "";
    if(used === 'course') { stPopTitle = action+" Categories Workshop"; }
    else if(used === 'library') { stPopTitle = action+" Categories Library"; }
    else if(used === 'prompt') { stPopTitle = action+" Categories Prompt"; }
    else if(used === 'discussion') { stPopTitle = action+" Categories Discussion"; }
    this.setState( prevState => {
      return {  
        ...prevState.stPopTitle, stPopTitle: stPopTitle,  
          ...prevState.isOpen2, isOpen2: true,
          ...prevState.otherContent, otherContent : '{"usageFor":"'+used.toLowerCase()+'","catId":"'+id+'"}'
      }
    })
  }
  urlformCat(used,id,action) {
    var stPopTitle = "";
    if(used === 'course') { stPopTitle = action+" Categories Workshop"; }
    else if(used === 'library') { stPopTitle = action+" Categories Library"; }
    else if(used === 'prompt') { stPopTitle = action+" Categories Prompt"; }
    else if(used === 'discussion') { stPopTitle = action+" Categories Discussion"; }
    this.setState( prevState => {
      return {  
          ...prevState.stPopTitle, stPopTitle: stPopTitle,
          ...prevState.isOpen, isOpen: true,
          ...prevState.otherContent, otherContent : '{"usageFor":"'+used.toLowerCase()+'","catId":"'+id+'"}'
      }
    })
  }
  urldeleteCat(used,valId) {
    var stat = false;
    stat = window.confirm("Are you sure you want to delete this data?");
    if(stat === true) {
      document.getElementById('loading-area').style.display = 'block'; 
      var urlString = global.config.urlLink+"/categorydelete";
      var datatext ='{"docid":"'+valId+'","usageFor":"'+used.toLowerCase()+'","form_id":"delete-cath"}';
      var data = JSON.parse(datatext); 
      fetch(urlString, {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Authorization': authKey,
        }, body : JSON.stringify(data)
      }).then(res => {
        if(res.status === 200) 
            return res.json() 
      }).then( resJson => {
          document.getElementById('loading-area').style.display = 'none'; 
          if(resJson.status === "200") {
              window.location.reload();
          } else {
              console.log('Something happened wrong delete');
          }
      }).catch(err => {
        document.getElementById('loading-area').style.display = 'none'; 
      });
    }
  }
  async loadData (value) {
    var [result1] = await Promise.all([loadContent(value,this.state.keyword,this.state.pageShow)]);
    var data_state = {
      [value]: result1
    };

    this.setState({
            data: data_state
        })
  }

  componentDidMount() {
    var currentURL = window.location.pathname;
    var arrPath = currentURL.split('/');
    var titlePage = ["Library","Library"];
    var usageFor = 'library'
    var defindex = "cat-1";
    if(arrPath[3] !== undefined && arrPath[3] !== "" && arrPath[3].toLowerCase() === "course") { defindex = "cat-2"; usageFor = "course"; titlePage = ["Workshop","Workshop"]; }
    else if(arrPath[3] !== undefined && arrPath[3] !== "" && arrPath[3].toLowerCase() === "prompt") { defindex = "cat-3"; usageFor = "prompt"; titlePage = ["Prompt Collection","Koleksi Prompting"]; }
    else if(arrPath[3] !== undefined && arrPath[3] !== "" && arrPath[3].toLowerCase() === "discussion") { defindex = "cat-4"; usageFor = "discussion"; titlePage = ["Discussion Room","Ruang Diskusi"]; }
    this.setState({
      stTitle: {"ENG": titlePage[0], "IDN": titlePage[1]},
      defTabIndex: defindex,
      usageFor: usageFor,
      activelink: arrPath[2]+"/"+arrPath[3]
    })
    this.loadData(usageFor);
  }

  contentTabs(param) {
    var statedata = this.state.data[param];

    var stLabel = "Library"; 
    if(param === 'course') { stLabel = "Workshop"; }
    else if(param === 'prompt') { stLabel = "Prompt"; }
    else if(param === 'discussion') { stLabel = "Discussion"; }
    var categoryList = [];
    if(statedata.values.length > 0 && statedata.status === '200') {
      for(var ls=0; ls < statedata.values.length; ls++) {
          var retResult = statedata.values[ls];
          categoryList.push(<tr key={retResult.docid}>
              <th scope="row-field" className="text-center">{ls+1}</th>
              <td>{retResult.content.categoryName}</td>
              <td>
                  <FaPen className="styleicons" aria-label="edit" onClick={this.urlformCat.bind(this, param,retResult.docid,'Edit')} />
                  <FaFileLines className="styleicons" aria-label="view" onClick={this.urlviewCat.bind(this, param,retResult.docid,'View')} />
                  <FaTrash className="styleicons" aria-label="delete" onClick={this.urldeleteCat.bind(this, this.state.usageFor, retResult.docid)} />
              </td>
            </tr>)
        }
    } else {
      categoryList.push(<tr key="1">
            <th scope="row"></th>
            <td className="d-flex p-3">- no data -</td>
            <td></td>
          </tr>)
    }
    
    return(<div>
              <div className="row show">
                  <div className="col-6"></div>
                  <div className="col-6 d-flex justify-content-end">
                      <Button variant="secondary" size="sm" onClick={this.urlformCat.bind(this, param.toLowerCase(),'','Add')}><FaPlus style={{color:"#FFFFFF", size: "20px"}} className="me-2" />Add Categories {stLabel}</Button>
                  </div>
              </div>
              <div className="mt-3">
                  <table className="table">
                    <thead className="table-dark">
                      <tr key="0">
                      <th width="50" className="text-center" scope="col">#</th>
                      <th scope="col">Category</th>
                      <th width="150" scope="col">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                        {categoryList}
                    </tbody>
                  </table>
              </div>
           </div>
    )
    
  }  

  render() {
    console.log("usageFor", this.state.usageFor)
    return (
      <div className="setting">
       <Container>
      {
        (localStorage.getItem("ulvl") === global.config.userLevel[0] || localStorage.getItem("ulvl") === global.config.userLevel[2])? 
        (<>
          <div className="row py-5 mb-5">
            {/* === start - body */}
              <div className="col-md-3 bg-light">
                { 
                  this.state.activelink !== "none" && 
                    <MenuLeftCMS value={{tabkey:this.state.activelink}}/>
                
                }
              </div>
              <div className="col-md-9 p-4">
                <div className="row">
                  <div className="mb-4">
                    <h3>{GetText() ? this.state.stTitle.IDN : this.state.stTitle.ENG}</h3>
                    <span className="text-muted">{GetText() ? "Daftar Kategori" : "List of Category"}</span>
                  </div>
                  <div className="mt-3">
                          <div>
                          {this.state.usageFor !== "" && this.contentTabs(this.state.usageFor)}
                          </div>
                  </div>
                </div>
              </div>
            {/* === end - body */}
          </div>
          <div>
                {this.state.isOpen && <Popup
                  content={<><CTCategoryForm/></>}
                  title={this.state.stPopTitle}
                  others={this.state.otherContent}
                  styles={"50%"}
                  handleClose={this.togglePopClose.bind(this)}
                />}
                {this.state.isOpen2 && <Popup
                  content={<><CTCategoryDetail/></>}
                  title={this.state.stPopTitle}
                  others={this.state.otherContent}
                  styles={"70%"}
                  handleClose={this.togglePopClose.bind(this)}
                />}
          </div>
          </>
        )
      : 
        <div><CTNA/></div>
      }
      <div id="loading-area" className="d-none loading"></div> 
      </Container>
      </div>
    );
  }
}
